// Owner/Admin — Antrean Produksi Offline: kartu divisi ringkas + daftar kartu bertahap.
import { useEffect, useState } from "react";
import "./production_admin_divisions.css";
import { AlertTriangle, ChevronDown } from "lucide-react";

const slug = (k) => k.replaceAll(" ", "-").replaceAll("/", "-");

function DivCard({ it, active, onPick }) {
  const { t, count, notaCount } = it;
  return <button type="button" role="tab" aria-selected={active} className={`pad-card${active ? " is-active" : ""}${count ? "" : " is-empty"}`}
    onClick={() => onPick(t.key)} data-testid={`prod-tab-${slug(t.key)}`}>
    <span className="pad-card-name">{t.label}</span>
    <span className="pad-card-team">{t.team}</span>
    <span className="pad-card-count" data-testid={`prod-tab-count-${slug(t.key)}`}>
      <b>{count}</b> produk · <b>{notaCount}</b> nota</span>
  </button>;
}

export function AdminDivisionGrid({ items, active, onPick, loaded }) {
  const check = items.find(i => i.t.key === "Perlu Diperiksa");
  const rest = items.filter(i => i !== check);
  const busy = rest.filter(i => i.count > 0).sort((a, b) => b.count - a.count);
  // Data belum termuat → jangan pindahkan divisi ke "Lainnya" seolah kosong.
  const main = loaded ? busy : rest;
  const others = loaded ? rest.filter(i => i.count === 0) : [];
  const activeInOthers = others.some(i => i.t.key === active);
  return <div className="pad" data-testid="prod-tabs" role="tablist">
    {check && <button type="button" role="tab" aria-selected={active === check.t.key}
      className={`pad-check${active === check.t.key ? " is-active" : ""}`} onClick={() => onPick(check.t.key)} data-testid="prod-tab-Perlu-Diperiksa">
      <AlertTriangle size={18} aria-hidden="true"/>
      <span className="pad-check-txt"><b>Perlu Diperiksa</b><small>Belum ditentukan rute produksinya · {check.t.team}</small></span>
      <span className="pad-check-count" data-testid="prod-tab-count-Perlu-Diperiksa"><b>{check.count}</b> produk · <b>{check.notaCount}</b> nota</span>
    </button>}
    <div className="pad-label">Antrean per Divisi{!loaded && " · memuat data…"}</div>
    <div className="pad-grid">{main.map(it => <DivCard key={it.t.key} it={it} active={active === it.t.key} onPick={onPick}/>)}</div>
    {others.length > 0 && <details className="pad-others" open={activeInOthers || undefined} data-testid="prod-other-divisions">
      <summary><ChevronDown size={14} aria-hidden="true"/> Divisi Lainnya · tanpa pekerjaan aktif ({others.length})</summary>
      <div className="pad-grid">{others.map(it => <DivCard key={it.t.key} it={it} active={active === it.t.key} onPick={onPick}/>)}</div>
    </details>}
  </div>;
}

const STEP = 30;
export function AdminPagedCards({ groups, render, resetKey }) {
  const [limit, setLimit] = useState(STEP);
  useEffect(() => { setLimit(STEP); }, [resetKey]);
  return <>
    {groups.slice(0, limit).map(render)}
    {groups.length > limit && <button type="button" className="pad-more" onClick={() => setLimit(l => l + STEP)} data-testid="prod-load-more">
      Tampilkan {Math.min(STEP, groups.length - limit)} lagi · {limit} dari {groups.length} nota</button>}
  </>;
}
